export default __webpack_public_path__ + "images/loggedout/home/reportstats_tablet-34b7789292d6c29c8fc5778bf92bf8ae.png";